import { TGetQuickviewContractorInfoResponseData } from "@zeal/common";
import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";

export const getQuickviewContractorInfo = (axios: IAxiosInstance) => {
  return async (contractorID: string) => {
    const response = await axios.noRetry.get<
      IApiResponse<TGetQuickviewContractorInfoResponseData>
    >(`/api/getQuickviewContractorInfo`, {
      params: { contractorID },
    });
    const resData = response.data;

    if (resData.success) {
      return resData.data;
    }

    throw new Error("Something went wrong");
  };
};
